import React, { FC, useCallback } from 'react';
import { DateRange } from '@material-ui/pickers';
import { Grid, IconButton } from '@material-ui/core';
import { SearchOutlined } from '@material-ui/icons';
import { useStyles } from './styles';
import { useCommonStyles } from '../../../styles';
import { DateRangeSelect } from '../../DateRangeSelect';

interface Props {
  translation: any;
  dateRange: DateRange<Date>;
  handleDateRangeChange: (date: DateRange<Date>) => void;
  showButton?: boolean;
  handleButtonClick?: () => void;
}

export const ReportsGeneralToolbar: FC<Props> = ({ translation, dateRange, handleDateRangeChange, handleButtonClick, showButton }) => {
  const classes = useStyles();
  const commonClasses = useCommonStyles();
  const [selectedDateRange, setSelectedDateRange] = React.useState<DateRange<Date>>(dateRange);

  const requestReport = useCallback(() => {
    if (handleButtonClick) {
      handleButtonClick();
    }
  }, [handleButtonClick]);

  return (
    <Grid container direction="row" justify="space-between" className={classes.toolbar}>
      <Grid item className={classes.filters}>
        <p className={commonClasses.formControlTitle}>{translation.text_6166}</p>
        <DateRangeSelect
          defaultValue={selectedDateRange}
          onRangeChange={(value) => {
            setSelectedDateRange(value);
            handleDateRangeChange(value);
          }}
        />
      </Grid>
      <Grid item style={{ alignSelf: 'flex-end' }}>
        {showButton && (
          <IconButton onClick={requestReport}>
            <SearchOutlined style={{ color: '#030C21' }} />
          </IconButton>
        )}
      </Grid>
    </Grid>
  );
};
